import * as React from "react";
import type { SVGProps } from "react";
const SvgTv = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.707 2.707a1 1 0 0 0-1.414-1.414zM12 7l-.707.707a1 1 0 0 0 1.414 0zM7.707 1.293a1 1 0 0 0-1.414 1.414zM4 8h16V6H4zm16 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v11h2V9zm0 11a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H4v2h16zM4 21a1 1 0 0 1-1-1H1a3 3 0 0 0 3 3zm-1-1V9H1v11zM3 9a1 1 0 0 1 1-1V6a3 3 0 0 0-3 3zm13.293-7.707-5 5 1.414 1.414 5-5zm-3.586 5-5-5-1.414 1.414 5 5z"
    />
  </svg>
);
export default SvgTv;
